import type { FC } from 'react';
import { useCallback, useMemo } from 'react';
import type { UseFetchHandlerOptions } from '@mwl/core-lib';
import { getTopLinesSB, selectUserCurrency, selectUserLocale, useFetch } from '@mwl/core-lib';
import { GroupedLines } from '@/components/GroupedLines/GroupedLines';
import { useTypedSelector } from '@/hooks';
import { sportLinesEnrichment } from '@/utils';
import type { TopLinesProps } from './TopLines.types';
export const TopLines: FC<TopLinesProps> = ({
  stage
}) => {
  const locale = useTypedSelector(selectUserLocale);
  const currency = useTypedSelector(selectUserCurrency);
  const fetchLines = useCallback(({
    signal
  }: UseFetchHandlerOptions) => getTopLinesSB({
    pageOffset: 0,
    pageSize: 10,
    stage
  }, {
    signal
  }), [stage]);
  const {
    data: linesResponse
  } = useFetch(`topLines_${stage}`, fetchLines, {
    disabled: !currency || !locale
  });
  const lines = useMemo(() => linesResponse ? sportLinesEnrichment(linesResponse) : [], [linesResponse]);
  if (!lines.length) {
    return null;
  }
  return <GroupedLines lines={lines} data-sentry-element="GroupedLines" data-sentry-component="TopLines" data-sentry-source-file="TopLines.tsx" />;
};